// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { fermentationProcedureId } from './FermentationProcedure';
import { fermentationGroupId } from './FermentationGroup';
import { formulaTemplateId } from './FormulaTemplate';
import { z } from 'zod';
export const kpiFormulaId = (z.number());
export const kpiFormula = z.object({
    id: kpiFormulaId,
    slug: z.string(),
    name: z.string(),
    description: z.string().nullable(),
    default_unit: z.string().nullable(),
    target_type: z.string().nullable(),
    display_group: z.string().nullable(),
    display_order: z.number().nullable(),
    created_at: z.date().nullable(),
    deleted_at: z.date().nullable(),
    expression: z.string(),
    unit: z.string().nullable(),
    precision: z.number().nullable(),
    division_by_zero_mode: z.string().nullable(),
    missing_value_mode: z.string().nullable(),
    procedure_id: fermentationProcedureId.nullable(),
    group_id: fermentationGroupId.nullable(),
    source_template_id: formulaTemplateId.nullable(),
    kind: z.string(),
});
export const kpiFormulaInitializer = z.object({
    id: kpiFormulaId.optional(),
    slug: z.string(),
    name: z.string(),
    description: z.string().optional().nullable(),
    default_unit: z.string().optional().nullable(),
    target_type: z.string().optional().nullable(),
    display_group: z.string().optional().nullable(),
    display_order: z.number().optional().nullable(),
    created_at: z.date().optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    expression: z.string(),
    unit: z.string().optional().nullable(),
    precision: z.number().optional().nullable(),
    division_by_zero_mode: z.string().optional().nullable(),
    missing_value_mode: z.string().optional().nullable(),
    procedure_id: fermentationProcedureId.optional().nullable(),
    group_id: fermentationGroupId.optional().nullable(),
    source_template_id: formulaTemplateId.optional().nullable(),
    kind: z.string().optional(),
});
export const kpiFormulaMutator = z.object({
    id: kpiFormulaId.optional(),
    slug: z.string().optional(),
    name: z.string().optional(),
    description: z.string().optional().nullable(),
    default_unit: z.string().optional().nullable(),
    target_type: z.string().optional().nullable(),
    display_group: z.string().optional().nullable(),
    display_order: z.number().optional().nullable(),
    created_at: z.date().optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    expression: z.string().optional(),
    unit: z.string().optional().nullable(),
    precision: z.number().optional().nullable(),
    division_by_zero_mode: z.string().optional().nullable(),
    missing_value_mode: z.string().optional().nullable(),
    procedure_id: fermentationProcedureId.optional().nullable(),
    group_id: fermentationGroupId.optional().nullable(),
    source_template_id: formulaTemplateId.optional().nullable(),
    kind: z.string().optional(),
});
//# sourceMappingURL=KpiFormula.js.map